module.exports = __webpack_public_path__ + "img/2-bg.1fa7c711.png";